import React, { FC, useState }                  from "react";
import { useDispatch, useSelector }             from "react-redux";
import { Button, Checkbox, Icon, Modal, Table } from "semantic-ui-react";
import GetMailGroups                            from "../../../application/usecase/mail/group/GetMailGroups";
import CustomerId                               from "../../../domain/customer/CustomerId";
import CustomerIds                              from "../../../domain/customer/CustomerIds";
import CurrentPage                              from "../../../domain/fundamentals/pagination/CurrentPage";
import CreatedAt                                from "../../../domain/fundamentals/trail/CreatedAt";
import Trail                                    from "../../../domain/fundamentals/trail/Trail";
import UpdatedAt                                from "../../../domain/fundamentals/trail/UpdatedAt";
import MailGroup                                from "../../../domain/mail/group/MailGroup";
import MailGroupId                              from "../../../domain/mail/group/MailGroupId";
import MailGroupName                            from "../../../domain/mail/group/MailGroupName";
import MailGroupRepository                      from "../../../domain/mail/group/MailGroupRepository";
import MailGroups                               from "../../../domain/mail/group/MailGroups";
import MailSendRepository                       from "../../../domain/mail/send/MailSendRepository";
import { ResKaState }                           from "../../../index";
import MailGroupDataSource
                                                from "../../../infrastructure/datasource/mail/group/MailGroupDataSource";
import MailSendDataSource                       from "../../../infrastructure/datasource/mail/send/MailSendDataSource";
import BottomSection                            from "../common/layout/BottomSection";
import ListTotalCount                           from "../common/layout/ListTotalCount";
import TopSection                               from "../common/layout/TopSection";
import ListPagination                           from "../common/ListPagination";

const MailSendDestinationGroupSelector: FC = () => {
  const [open, setOpen] = useState(false);
  const [selectedMailGroups, setMailGroups] = useState(new MailGroups());
  const mailGroups: MailGroups = useSelector((state: ResKaState) => state.mailGroups);
  const repository: MailSendRepository = new MailSendDataSource(useDispatch());
  const mailGroupRepository: MailGroupRepository = new MailGroupDataSource(useDispatch());
  const getMailGroups: GetMailGroups = new GetMailGroups(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => {
          getMailGroups.execute(new CurrentPage());
          setMailGroups(new MailGroups());
          setOpen(true);
        } }
      >
        <Icon name="users"/>
        送信先グループを選択する
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>送信先グループの選択</Modal.Header>

        <Modal.Content>
          <TopSection>
            <Button
              onClick={ () => {
                mailGroupRepository.findAll().then(response => {
                  const list: MailGroup[] = response.data.mailGroups.map(mailGroup => new MailGroup(
                    new MailGroupId(mailGroup.id),
                    new MailGroupName(mailGroup.name),
                    new CustomerIds(mailGroup.customerIds.map(customerId => new CustomerId(customerId))),
                    new Trail(
                      new CreatedAt(mailGroup.trail.createdAt),
                      new UpdatedAt(mailGroup.trail.updatedAt),
                    )
                  ));
                  setMailGroups(new MailGroups(list));
                })
              } }
            >
              全選択
            </Button>
            <Button
              onClick={ () => setMailGroups(new MailGroups()) }
            >
              全解除
            </Button>
          </TopSection>
          {
            mailGroups.isEmpty()
              ?
              <p>メールグループが作成されていません。</p>
              :
              <>
                <ListTotalCount>{ mailGroups.count.toString() }</ListTotalCount>
                <Table
                  striped
                  selectable
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>選択</Table.HeaderCell>
                      <Table.HeaderCell>メールグループ名</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {
                      mailGroups.toList().map(mailGroup => (
                        <Table.Row
                          onClick={ () => selectedMailGroups.has(mailGroup.id) ? setMailGroups(selectedMailGroups.remove(mailGroup)) : setMailGroups(selectedMailGroups.add(mailGroup)) }
                        >
                          <Table.Cell width={ 2 }>
                            <Checkbox
                              checked={ selectedMailGroups.has(mailGroup.id) }
                              onChange={ () => selectedMailGroups.has(mailGroup.id) ? setMailGroups(selectedMailGroups.remove(mailGroup)) : setMailGroups(selectedMailGroups.add(mailGroup)) }
                            />
                          </Table.Cell>
                          <Table.Cell>{ mailGroup.name.value }</Table.Cell>
                        </Table.Row>
                      ))
                    }
                  </Table.Body>
                </Table>

                <BottomSection>
                  <ListPagination
                    currentPage={ mailGroups.pagination.current }
                    totalPage={ mailGroups.pagination.total }
                    onChangePage={ currentPage => getMailGroups.execute(currentPage) }
                  />
                </BottomSection>
              </>
          }
        </Modal.Content>

        <Modal.Actions>
          <Button
            icon
            labelPosition="left"
            disabled={ selectedMailGroups.isEmpty() }
            positive={ !selectedMailGroups.isEmpty() }
            onClick={ () => {
              repository.setMailSendGroups(selectedMailGroups);
              setOpen(false);
            } }
          >
            <Icon name="check"/>
            決定する
          </Button>

          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default MailSendDestinationGroupSelector;
